import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import HeroSection from '../layouts/HeroSection';
import HomeLayout from '../layouts/Home-Layout';
import {
  ArrowRight, Facebook, Linkedin, Youtube, Instagram, Music2,
  Menu, ChevronUp, ChevronDown, Timer, Mountain, Sun,
  ArrowDown, YoutubeIcon, Play, MapPin, Mic2,
  User, ChevronRight, Clock, Calendar,
  BookOpenIcon,
  ChevronLeft, BookOpen, Download,
  Twitter,
  ExternalLink,
  Map,
  AlarmCheck,
  VideoIcon,
  Heart, MessageCircle, Brain, Users
} from 'lucide-react';
import { Text, View } from '../api/edit-react';
import { motion, AnimatePresence, easeInOut, easeOut } from "framer-motion";

import { LatLngTuple } from 'leaflet'
import L from "leaflet";
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'
import ImagesDev from '../api/images';
import EmblaCarousel from '../api/EmblaCarousel';
import useFetchYouTubeResources from '../api/useFetchYouTubeResources';
import { audioLinks, videoLinks } from '../api/youtubeLinks';
import { WordOfTheDay } from '../components/home/WordOfTheDay';
import { PostOfTheDay } from '../components/PostOfTheDay';
import { EventsHighlights } from '../components/EventsHighlights';
import Link from '../components/Link';
import { addToCalender } from '../api/addToCalender';
import { fetchLibraryItems } from '../api/adminService';
import { dailyDeclarations, testimonials } from '../data/mockData';
import DailyDeclarations from '../components/home/DailyDeclarations';
import TestimonialsSection from '../components/home/TestimonialsSection';
import QuizSection from '../components/home/QuizSection';

const slides = [
  // {
  //   id: 1,
  //   image: ImagesDev.litsImg,
  //   title: "Life in the Spirit",
  //   description: "Discover how to walk in faith and embrace a life led by the Spirit, filled with purpose and divine direction.",
  //   bgColor: "#22001F",
  //   date: "February 28, 2025",
  //   location: "3C, OLAIDE BENSON CLOSE, MARYLAND, LAGOS.",
  //   url: "/ministries/life-in-the-spirit"
  // },
  // {
  //   id: 2,
  //   image: ImagesDev.BSImg,
  //   title: "How To Read The Bible",
  //   description: "Learn practical steps to study the Bible effectively, unlocking deeper understanding and spiritual growth.",
  //   bgColor: "#080012",
  //   date: "October 26, 2024",
  //   location: "NECA House, Hakeem Balogun Street, Alausa, Ikeja.",
  //   url: "/ministries/bible-study"
  // },
  // {
  //   id: 3,
  //   image: ImagesDev.hpGImg,
  //   title: "The Healing Party - Ghana",
  //   description: "Experience a powerful movement of faith, healing, and miracles at The Healing Party in Ghana.",
  //   bgColor: "#131A00",
  //   date: "November 30, 2024",
  //   location: "Shekinah Avenue Auditorium, Accra.",
  //   url: "/ministries/healing-party"
  // },
  {
    id: 1,
    image: ImagesDev.events.bbb.bg,
    title: "Birthday Bible Brunch",
    description: "It was TSO’s 33rd birthday. It was a wonderful day, celebrated by sharing the Bible with family and friends!",
    bgColor: "#FFEEF1",
    activeColor: "bg-pink-700",
    date: "May 16, 2025",
    location: "Business Club, 50 Hakeem Balogun St, Ikeja, Lagos",
    url: "/birthday-bible-brunch"
  },
  {
    id: 2,
    image: ImagesDev.litsImg2,
    title: "L.O.G.I.C. Evening Church & Life In The Spirit",
    description: "An unforgettable night of divine encounters, supernatural healing, and a powerful outpouring of the Holy Spirit.",
    bgColor: "#080012",
    activeColor: "bg-amber-500",
    date: "October 26, 2024",
    location: "Logic Hq, T.F Kuboye Road, Marwa, Lekki, Lagos",
    url: "/ministries/life-in-the-spirit"
  },
  {
    id: 1,
    image: ImagesDev.litsImg,
    title: "Life in the Spirit",
    description: "Discover how to walk in faith and embrace a life led by the Spirit, filled with purpose and divine direction.",
    bgColor: "#22001F",
    activeColor: "bg-red-700",
    date: "February 28, 2025",
    location: "3C, OLAIDE BENSON CLOSE, MARYLAND, LAGOS.",
    url: "/ministries/life-in-the-spirit"
  },
];

const socialLinks = [
  { icon: Instagram, url: 'https://www.instagram.com/titothewriter/', label: 'Instagram' },
  { icon: Facebook, url: 'https://web.facebook.com/profile.php?id=61556604022000', label: 'Facebook' },
  { icon: Music2, url: 'https://www.tiktok.com/@titothewriter1?is_from_webapp=1&sender_device=pc', label: 'TikTok' },
  { icon: Youtube, url: 'https://www.youtube.com/@titothewriter', label: 'YouTube' }
];

const socialLinks_ = [
  {
    platform: 'Instagram',
    handle: '@titothewriter',
    url: 'https://www.instagram.com/titothewriter/',
    icon: Instagram,
    color: 'hover:text-pink-500'
  },
  {
    platform: 'Twitter (X)',
    handle: '@titothewriter',
    url: 'https://twitter.com/titothewriter',
    icon: Twitter,
    color: 'hover:text-blue-400'
  },
  {
    platform: 'YouTube',
    handle: '@titothewriter',
    url: 'https://www.youtube.com/@titothewriter',
    icon: Youtube,
    color: 'hover:text-red-500'
  },
  {
    platform: 'TikTok',
    handle: '@titothewriter1',
    url: 'https://www.tiktok.com/@titothewriter1',
    icon: Music2,
    color: 'hover:text-purple-500'
  }
];

const OPTIONS = { loop: true }


function Home() {
  const targetDate = new Date("2025-02-28T18:00:00+01:00");
  return (
    <div>
      <PageBG_effect />
      <HeroSection_Desktop /> <HeroSection_Mobile />
      <WordOfTheDay />
      <App_countdown /> <Mobile_section1 targetDate={targetDate} />
      <DailyDeclarations />
      {/* <Section_zoom_thp /> */}
      <AboutMinisters />
      <IntroCarousel />
      <Highlights />
      <TeachingsSection />
      <TestimonialsSection />
      <Slider_component />
      <QuizSection />
    </div>
  );
}


function PageBG_effect() {
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-gradient-to-br from-tc-gold via-indigo-800 to-orange-900">
      {/* Animated gradient overlays */}
      <div className="absolute inset-0 opacity-90">
        <div className="absolute inset-0 bg-black bg-opacity-70"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_70%,rgba(236,72,153,0.8)_0,rgba(236,72,153,0)_70%)] animate-pulse-slow animation-delay-400"></div>
      </div>
      {/* Animated particle effect */}
      <div className="absolute inset-0 overflow-hidden">
        {Array.from({ length: 20 }).map((_, i) => (
          <div
            key={i}
            className="absolute rounded-full bg-white opacity-20"
            style={{
              width: `${Math.random() * 6 + 2}px`,
              height: `${Math.random() * 6 + 2}px`,
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animation: `float ${Math.random() * 10 + 10}s linear infinite`,
              animationDelay: `${Math.random() * 10}s`
            }}
          ></div>
        ))}
      </div>
    </div>
  )
}


function HeroSection_Desktop() {
  const heroNav = [
    // {title:"ABOUT", url: "/about"}, 
    { title: "HEALING PARTY", url: "/ministries/healing-party" },
    { title: "BIBLE STUDY", url: "/ministries/bible-study" },
    { title: "LIFE IN THE SPIRIT", url: "/ministries/life-in-the-spirit" },
    // {title:"EVENTS", url: "/gallery"}
  ]
  return (
    <div className="hidden md:grid relative text-white min-h-screen">
      {/* Hero Section */}
      <section className="">
        <div className="relative h-[100vh] overflow-hidden ">
          <HeroSlider ImagesDev={ImagesDev} heroNav={heroNav} />
        </div>
      </section>
    </div>
  );
}
function HeroSlider({ heroNav }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [direction, setDirection] = useState(1);

  const slides = [
    {
      id: 1,
      title: 'T.S.O Ministries',
      subTitle: "Till every eye sees Jesus",
      subTitle2: "",
      // subTitle2: "Proclaiming Christ to all nations",
      // image: ImagesDev.heroImagesDesk[1],
      image: "https://tsoministries.com/wp-content/uploads/2025/06/IMG_2850--scaled.jpg",
      bgClass: ""
    },
    {
      id: 2,
      title: 'Redeeming Love',
      subTitle: "Saved by His sacrifice",
      subTitle2: "Accepted into the Beloved",
      // image: ImagesDev.heroImages[5],
      image: "https://tsoministries.com/wp-content/uploads/2025/06/IMG_2861--scaled.jpg",
      bgClass: "object-[center_35%]"
    },
    {
      id: 3,
      title: 'Living Word',
      subTitle: "Every promise fulfilled",
      subTitle2: "As Christ Is Revealed",
      // subTitle2: "The Gospel That Transforms",
      // image: ImagesDev.heroImagesDesk[3],
      image: "https://tsoministries.com/wp-content/uploads/2025/06/IMG_2859-.jpg",
      bgClass: ""
    },
    {
      id: 4,
      title: 'Eternal Light',
      subTitle: "Shining in the darkness",
      subTitle2: "I carry That Light!",
      // image: ImagesDev.heroImagesDesk[0],
      image: "https://tsoministries.com/wp-content/uploads/2025/06/IMG_2857-.jpg",
      bgClass: ""
    }
  ];

  const nextSlide = () => {
    setDirection(1);
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setDirection(-1);
    setCurrentSlide((prev) =>
      prev === 0 ? slides.length - 1 : prev - 1
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 6000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [currentSlide]);

  const imageVariants = {
    initial: (direction) => ({
      opacity: 0,
      x: direction > 0 ? "100%" : "-100%", // Start off-screen
    }),
    animate: {
      x: "0%", // Move to center
      opacity: 1,
      transition: { duration: 1.7, ease: easeInOut, delay: 0.1 },
    },
    exit: (direction) => ({
      x: direction > 0 ? "-100%" : "100%", // Move out of screen
      opacity: 0,
      transition: { duration: 1.3, ease: easeInOut, delay: 0.5 },
    }),
  };
  const textVariants = {
    initial: (delay) => ({
      clipPath: "inset(0% 0% 0% 100%)",
      x: "-100%",
      opacity: 1,
    }),
    animate: (delay) => ({
      clipPath: "inset(0% 0% 0% 0%)",
      x: "0%",
      opacity: 1,
      transition: {
        duration: 0.7, ease: easeOut,
        delay: delay === 1 ? 1 : delay === 2 ? 1.3 : 1
      },
    }),
    exit: (delay) => ({
      clipPath: "inset(0% 0% 0% 0%)",
      x: "0%",
      opacity: 0,
      transition: { duration: 0.5, ease: "easeIn", delay: 0.6 },
    }),
  };



  return (
    <div className="relative w-full h-screen overflow-hidden bg-gray-900">
      <AnimatePresence mode="popLayout">
        <motion.div
          key={slides[3].id}
          initial={{ opacity: 1, x: "0%" }}
          animate={{ opacity: 0, x: "-100%", transition: { duration: 1.7, ease: easeInOut, delay: 0.1 } }}
          exit={{ opacity: 0, x: "-100%", transition: { duration: 1.7, ease: easeInOut, delay: 0.1 } }}
          className="absolute inset-0"
        >
          <img
            src={slides[3].image}
            alt={slides[3].title}
            className={`w-full h-full object-cover ${slides[3].bgClass}`}
          />
          <div className="absolute inset-0 bg-black bg-opacity-30" />
        </motion.div>
      </AnimatePresence>

      <AnimatePresence mode="popLayout" custom={direction}>
        <motion.div
          key={slides[currentSlide].id}
          variants={imageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          custom={direction}
          className="absolute inset-0"
        >
          <img
            src={slides[currentSlide].image}
            alt={slides[currentSlide].title}
            className={`w-full h-full object-cover ${slides[currentSlide].bgClass}`}
          />
          <div className="absolute inset-0 bg-black bg-opacity-30" />
        </motion.div>
      </AnimatePresence>

      {/* Wipe effect for text */}
      <div className='h-full absolute text-white px-64 flex flex-col justify-center'>
        {[1, 2, 3].map((val, ind) => {
          return (
            val === 3 ?
              <div className="text-white w-[70vw] flex flex-row my-10 fonseca-thin">
                <AnimatePresence mode="popLayout" custom={val}>
                  <motion.div
                    key={slides[currentSlide].id}
                    variants={textVariants}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                    custom={val}
                    className="relative w-[13vw]"
                  >
                    <p>{slides[currentSlide].subTitle}</p>
                  </motion.div>
                </AnimatePresence>
                <AnimatePresence mode="popLayout" custom={val}>
                  <motion.div
                    key={slides[currentSlide].id}
                    variants={textVariants}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                    custom={val}
                    className="relative w-[15vw]"
                  >
                    <p>{slides[currentSlide].subTitle2}</p>
                  </motion.div>
                </AnimatePresence>
              </div>
              :
              val === 1 ?
                <div className="text-white w-[40vw] flex flex-row mb-2 mt-12">
                  <AnimatePresence mode="popLayout" custom={val}>
                    <motion.div
                      key={slides[currentSlide].id}
                      variants={textVariants}
                      initial="initial"
                      animate="animate"
                      exit="exit"
                      custom={val}
                      className="relative"
                    >
                      <span className="block text-4xl">0{slides[currentSlide].id}</span>
                    </motion.div>
                  </AnimatePresence>
                  <AnimatePresence mode="popLayout" custom={val}>
                    <motion.div
                      key={slides[currentSlide].id}
                      variants={textVariants}
                      initial="initial"
                      animate="animate"
                      exit="exit"
                      custom={val}
                      className="relative"
                    >
                      <span className="block text-sm pt-1 opacity-50">/0{slides.length}</span>
                    </motion.div>
                  </AnimatePresence>
                </div>
                :
                <div className="text-white">
                  <AnimatePresence mode="popLayout" custom={val}>
                    <motion.div
                      key={slides[currentSlide].id}
                      variants={textVariants}
                      initial="initial"
                      animate="animate"
                      exit="exit"
                      custom={val}
                      className="relative"
                    >
                      <h1 className="text-9xl font-extrabold capitalize tracking-wide inline-block">
                        {slides[currentSlide].title.split(" ").map((word, index) => {
                          return <div key={index}>{word}</div>;
                        })}
                      </h1>
                    </motion.div>
                  </AnimatePresence>
                </div>
          )
        })}
      </div>

      {/* Suplimentary information */}
      <motion.nav
        className="hidden absolute bottom-28 left-[14vw] flex flex-wrap justify-center gap-6 md:gap-12 my-10 mb-2 text-sm tracking-widest"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 2.2 }}
      >
        <p className="text-md mt-2 text-gray-200">
          TSO Ministries (Titoluwa Olumideko Ministries) <br />
          <span style={{ fontSize: 11 }}>#Titoluwa Ministries, #TitoTheWriter, #TSO.</span>
        </p>
        <p className="text-md mt-2 text-gray-200 opacity-0">
          TSO Ministries (Titoluwa Olumideko Ministries) <br />
          Also known as Titoluwa Ministries, TitoTheWriter, and TSO.
        </p>
      </motion.nav>

      {/* Navigation */}
      <motion.nav
        className="absolute bottom-16 left-[14vw] flex flex-wrap justify-center gap-6 md:gap-12 my-10 mb-2 text-sm tracking-widest"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 2.2 }}
      >
        {heroNav.map((item, index) => (
          <a
            key={index}
            href={item.url}
            className="relative group py-2"
          >
            <span className="relative z-10 text-white/35 hover:text-orange-300 transition-colors duration-300">{item.title}</span>
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 group-hover:w-full transition-all duration-300"></span>
            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-orange-400 opacity-20 group-hover:w-0 transition-all duration-300"></span>
          </a>
        ))}
      </motion.nav>

      {/* Social Media Icons */}
      <motion.div
        className="absolute bottom-16 right-[14vw] flex justify-center gap-8 my-1"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 2.6 }}
      >
        {socialLinks.map((social, index) => (
          <a
            key={index}
            href={social.url}
            className="text-gray-400 hover:text-white transition-all duration-300 transform hover:scale-110 hover:text-purple-300"
            aria-label={social.label}
          >
            <social.icon size={20} />
          </a>
        ))}
      </motion.div>

      {/* Scroll indicator */}
      <motion.div
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity, ease: easeInOut }}
      >
        <ArrowDown className="text-white/70 w-6 h-6" />
      </motion.div>

      <div onClick={prevSlide}
        className="cursor-pointer absolute top-0 left-0 bg-black/10 hover:backdrop-blur-sm transition-all duration-[600ms] flex items-center justify-center h-screen w-[8vw] border-r border-[rgba(255,255,255,0.3)]"
      >
        <div className="-rotate-90 text-xl opacity-30">PREV</div>
      </div>
      <div onClick={nextSlide}
        className="cursor-pointer absolute top-0 right-0 bg-black/10 hover:backdrop-blur-sm transition-all duration-[600ms] flex items-center justify-center h-screen w-[8vw] border-l border-[rgba(255,255,255,0.3)]"
      >
        <div className="-rotate-90 text-xl opacity-30">NEXT</div>
      </div>
    </div>
  );
}

function HeroSection_Mobile() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);

  const nextSlide = () => {
    setDirection(1);
    setIndex((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setDirection(-1);
    setIndex((prev) =>
      prev === 0 ? slides.length - 1 : prev - 1
    );
  };

  const bubbles = [
    {
      id: "1",
      title: "the Gospel to You",
      subTitle: "Outreaches All over the Continnet",
      thumbnail: ImagesDev.heroImagesDesk[8],
    },
    {
      id: "2",
      title: "About Jesus",
      subTitle: "Don't miss out on our Bible Study",
      thumbnail: ImagesDev.heroImagesDesk[4],
    },
    {
      id: "3",
      title: "Coming live",
      subTitle: "Check out our events, be there!",
      thumbnail: ImagesDev.heroImagesDesk[9],
    }
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 6000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [index]);

  const heroNav = [
    { title: "HEALING PARTY", url: "/ministries/healing-party" },
    { title: "BIBLE STUDY", url: "/ministries/bible-study" },
    { title: "LIFE IN THE SPIRIT", url: "/ministries/life-in-the-spirit" },
  ]

  const slides = [
    {
      id: 1,
      title: 'T.S.O Ministries',
      subTitle: "Till every eye sees Jesus",
      subTitle2: "",
      // subTitle2: "Proclaiming Christ to all nations",
      // image: ImagesDev.heroImagesDesk[1],
      image: "https://tsoministries.com/wp-content/uploads/2025/06/5C66D15D-CE5B-44C0-A350-C1E6B69706C5.jpg",
      bgClass: ""
    },
    {
      id: 2,
      title: 'Redeeming Love',
      subTitle: "Saved by His sacrifice",
      subTitle2: "Accepted into the Beloved",
      // image: ImagesDev.heroImages[5],
      image: "https://tsoministries.com/wp-content/uploads/2025/06/IMG_2862-.jpg",
      bgClass: "object-[center_35%]"
    },
    {
      id: 3,
      title: 'Living Word',
      subTitle: "Every promise fulfilled",
      subTitle2: "As Christ Is Revealed",
      // subTitle2: "The Gospel That Transforms",
      // image: ImagesDev.heroImagesDesk[5],
      image: "https://tsoministries.com/wp-content/uploads/2025/06/IMG_2855-.jpg",
      bgClass: ""
    },
    {
      id: 4,
      title: 'Eternal Light',
      subTitle: "Shining in the darkness",
      subTitle2: "I carry That Light!",
      // image: ImagesDev.heroImages[10],
      image: "https://tsoministries.com/wp-content/uploads/2025/06/IMG_2848--scaled.jpg",
      bgClass: ""
    }
  ];

  const imageVariants = {
    initial: (direction) => ({
      opacity: 0,
      borderStartEndRadius: 50, borderStartStartRadius: 50,
      y: direction > 0 ? "100%" : "-100%", // Start off-screen
    }),
    animate: {
      y: "0%",
      opacity: 1,
      borderStartEndRadius: 0, borderStartStartRadius: 0,
      transition: { duration: 1.7, ease: easeInOut, delay: 0.1 },
    },
    exit: (direction) => ({
      y: direction > 0 ? "-100%" : "100%", // Move out of screen
      opacity: 0, borderStartEndRadius: 50, borderStartStartRadius: 50,
      transition: { duration: 1.3, ease: easeInOut, delay: 0.5 },
    }),
  };
  const textVariants = {
    initial: (delay) => ({
      clipPath: "inset(100% 0% 0% 0%)",
      y: "-100%",
      opacity: 1,
    }),
    animate: (delay) => ({
      clipPath: "inset(0% 0% 0% 0%)",
      y: "0%",
      opacity: 1,
      transition: {
        duration: 0.7, ease: easeOut,
        delay: delay === 1 ? 1 : delay === 2 ? 1.3 : 1
      },
    }),
    exit: (delay) => ({
      clipPath: "inset(0% 0% 0% 0%)",
      y: "0%",
      opacity: 0,
      transition: { duration: 0.5, ease: "easeIn", delay: 0.6 },
    }),
  };

  return (
    <div className="flex md:hidden relative w-screen h-screen overflow-hidden flex-column bg-black">
      <div className="relative w-screen h-[80vh] overflow-hidden bg-black" style={{ borderEndEndRadius: "0%", borderEndStartRadius: "0%", zIndex: 1, borderStartEndRadius: 50, borderStartStartRadius: 50, boxShadow: "0px 0px 20px 10px rgba(0,0,0,0.6)" }}>

        <AnimatePresence mode="popLayout" custom={direction}>
          <motion.div
            key={slides[index].id}
            variants={imageVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            custom={direction}
            className="absolute inset-0"
          >
            <img
              src={slides[index].image}
              alt={slides[index].title}
              style={{ borderStartEndRadius: 50, borderStartStartRadius: 50, }}
              className={`w-full h-full object-cover ${slides[index].bgClass}`}
            />
            <div className="absolute inset-0 bg-black bg-opacity-30" />
          </motion.div>
        </AnimatePresence>

        <AnimatePresence mode='wait'>
          <motion.div
            key={index}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 2, delay: 1 }}
            className="absolute inset-0 flex items-center justify-center"
          >
            <div className='absolute h-full w-full bg-black bg-opacity-0'></div>
          </motion.div>
        </AnimatePresence>

        {/* Wipe effect for text */}
        <div className='h-full absolute text-white px-8 flex flex-col justify-center'>
          {[1, 2, 3].map((val, ind) => {
            return (
              val === 3 ?
                <div className="text-white w-[70vw] flex flex-row my-8 fonseca-thin">
                  <AnimatePresence mode="popLayout" custom={val}>
                    <motion.div
                      key={slides[index].id}
                      variants={textVariants}
                      initial="initial"
                      animate="animate"
                      exit="exit"
                      custom={val}
                      className="relative w-[40vw]"
                    >
                      <p>{slides[index].subTitle}</p>
                    </motion.div>
                  </AnimatePresence>
                  <AnimatePresence mode="popLayout" custom={val}>
                    <motion.div
                      key={slides[index].id}
                      variants={textVariants}
                      initial="initial"
                      animate="animate"
                      exit="exit"
                      custom={val}
                      className="relative w-[40vw]"
                    >
                      <p>{slides[index].subTitle2}</p>
                    </motion.div>
                  </AnimatePresence>
                </div>
                :
                val === 1 ?
                  <div className="text-white w-[40vw] flex flex-row mb-2 mt-32">
                    <AnimatePresence mode="popLayout" custom={val}>
                      <motion.div
                        key={slides[index].id}
                        variants={textVariants}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                        custom={val}
                        className="relative"
                      >
                        <span className="block text-2xl">0{slides[index].id}</span>
                      </motion.div>
                    </AnimatePresence>
                    <AnimatePresence mode="popLayout" custom={val}>
                      <motion.div
                        key={slides[index].id}
                        variants={textVariants}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                        custom={val}
                        className="relative"
                      >
                        <span className="block text-sm pt-1 opacity-50">/0{slides.length}</span>
                      </motion.div>
                    </AnimatePresence>
                  </div>
                  :
                  <div className="text-white w-[75vw]">
                    <AnimatePresence mode="popLayout" custom={val}>
                      <motion.div
                        key={slides[index].id}
                        variants={textVariants}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                        custom={val}
                        className="relative"
                      >
                        <h1 className="text-6xl mb-0 tb-0 font-extrabold capitalize tracking-wide inline-block">
                          {slides[index].title}
                        </h1>
                      </motion.div>
                    </AnimatePresence>
                  </div>
            )
          })}
          {/* Suplimentary information */}
          <motion.nav
            className="relative flex flex-wrap  gap-6 md:gap-12 mb-10 text-sm tracking-widest"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 2.2 }}
          >
            <p className="text-[7px] mt-2 text-gray-200 opacity-0" style={{ lineHeight: 1 }}>
              TSO Ministries (Titoluwa Olumideko Ministries) <br />
              <span style={{ fontSize: 7, }}>#Titoluwa Ministries, #TitoTheWriter, #TSO.</span>
            </p>
            <p className="absolute text-xs mt-2 text-gray-200 opacity-0">
              TSO Ministries (Titoluwa Olumideko Ministries) <br />
              Also known as Titoluwa Ministries, TitoTheWriter, and TSO.
            </p>
          </motion.nav>

        </div>



        {/* Social Media Icons */}
        <motion.div
          className="absolute bottom-[12vh] w-full flex justify-center gap-8 my-1"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 2.6 }}
        >
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              className="text-gray-400 hover:text-white transition-all duration-300 transform hover:scale-110 hover:text-purple-300"
              aria-label={social.label}
            >
              <social.icon size={20} />
            </a>
          ))}
        </motion.div>
      </div>


      <div className="absolute bottom-0 w-screen h-[30vh] overflow-hidden bg-white" style={{ borderStartEndRadius: 50, borderStartStartRadius: 50, zIndex: 1, boxShadow: "0px 0px 20px 10px rgba(0,0,0,0.6)" }}>
        <div className='relative p-2 bg-white'>
          <h1 className='text-xl p-1 px-3 pt-3 pb-0 text-right fonseca-bold'>T.S.O. Ministries</h1>
          <h1 className='text-sm p-1 px-3 pb-4 pt-0 text-right fonseca'>(Titoluwa Olumideko Ministries)</h1>
          {/* <div className='h-6 w-[40vw] bg-gray-300 rounded-3xl m-1 mx-3'></div> */}

          <div className='overflowX-scroll rounded-3xl' style={{ overflowX: "scroll", overflowY: "hidden" }}>
            <div className='flex flex-row gap-2 w-[200vw]'>
              {bubbles.map((value, index) => {
                return (
                  <div key={value.id} className='h-[25vw] w-[60vw] bg-amber-600 rounded-3xl flex flex-col'>
                    <div className='w-full pt-1 pb-0 p-6 text-white text-sm h-full flex flex-col justify-center'>
                      <h1 className='font-bold' style={{ fontSize: 11 }}>{value.subTitle}</h1>
                      {/* <p>{value.subTitle}</p> */}
                    </div>
                    <div className='p-2 pt-1'>
                      <img
                        src={value.thumbnail}
                        alt={value.title}
                        className='rounded-2xl w-full h-[17vw] object-cover'
                      />
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>

        {/* Navigation */}
        <motion.nav
          className="w-full flex flex-wrap justify-center px-2 gap-6 md:gap-12 my-1 mb-2 text-sm tracking-widest"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 2.2 }}
        >
          {heroNav.map((item, index) => (
            <a
              key={index}
              href={item.url}
              className="relative group py-2"
              style={{ fontSize: 12 }}
            >
              <span className="relative z-10 hover:text-orange-300 transition-colors duration-300">{item.title}</span>
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-400 group-hover:w-full transition-all duration-300"></span>
              <span className="absolute bottom-0 left-0 w-full h-0.5 bg-orange-400 opacity-20 group-hover:w-0 transition-all duration-300"></span>
            </a>
          ))}
        </motion.nav>
      </div>

    </div>
  );
}

const handleReminderClick = () => {
  const now = new Date();
  const startDate = new Date(now);
  startDate.setHours(6, 0, 0, 0);

  if (now > startDate) {
    startDate.setDate(startDate.getDate() + 1);
  }
  addToCalender({
    title: "Morning Prayer Meeting – TSO Ministries",
    description: "Start your day with God. 🙏🏽",
    location: "https://us06web.zoom.us/j/87232094712?pwd=P5qPJ9dAeeZKuEcQahKHbyO80olaAg.1",
    start: startDate,
    time: [6, 0],
    // start: [2025, 7, 3, 6, 0], // [YYYY, MM, DD, HH, mm]
    duration: { hours: 0, minutes: 30 },
    fileName: "Morning_Prayer_Meeting.ics",
    repeat: "weekdays"
  });
};
function Section_zoom_thp() {
  return (
    <div className='relative bg-white'>
      <img className='absolute bottom-0 h-[30vw] w-[40vw] opacity-20' src={ImagesDev.futuristic_pattern} style={{ objectFit: "cover" }} />
      <img className='absolute bottom-[20vw] left-0 h-[20vw] w-[40vw] opacity-20 ' src={ImagesDev.futuristic_pattern} style={{ objectFit: "cover" }} />

      <section className="relative py-24 pt-8 text-black">

        <div className="text-center mb-2 lg:mb-12">
          <h2 className="text-xl md:text-4xl font-bold text-black mb-4">Happening Now at TSO Ministries</h2>
          <div className="h-1 w-24 bg-gradient-to-r from-orange-400 to-amber-400 mx-auto"></div>
        </div>

        <div className="container mx-auto lg:px-4">
          <div className="grid md:grid-cols-2 gap-6 lg:gap-12 max-w-7xl mx-auto">
            {/* https://tsoministries.com/wp-content/uploads/2025/09/mentorship_with_hs.jpg */}
            {/* Healing Party Section */}
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="relative overflow-hidden"
            >
              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-pink-500/20 h-full">
                <div className="absolute top-0 right-0 w-64 h-64 bg-pink-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>

                <div className="flex items-center gap-4 mb-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-amber-600 to-pink-600 rounded-xl flex items-center justify-center">
                    <Map className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold">Mentorship With HS</h3>
                </div>

                <div className="mb-6">
                  <p className="text-gray-400">
                    ...designed to help you read the Bible with Jesus at the center of every passage.
                  </p>
                </div>

                <div className="aspect-[4/4] rounded-xl overflow-hidden mb-6 mt-4">
                  <img
                    src={"https://tsoministries.com/wp-content/uploads/2026/04/Bible-Study-Masterclass-0.jpg.jpeg"}
                    alt="Mentorship With HS"
                    className="w-full h-full object-cover"
                  />
                </div>

                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={() => window.location.href = "/bst-masterclass"}
                  className="w-full py-3 bg-gradient-to-r from-rose-600 to-rose-800 rounded-lg text-white flex items-center justify-center gap-2"
                >
                  <span>Register Now</span>
                  <ArrowRight className="w-5 h-5" />
                </motion.button>

                {/* <div className="mb-0">
                  <p className="text-gray-400">
                    <span className='font-bold'>The-CONDO</span> Hosted by Pastor TitOluwa Olumideko <br />
                    VICTORIA ISLAND, LAGOS. - AUGUST 2025
                  </p>
                </div> */}

              </div>
            </motion.div>

            {/* Zoom Link Section */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="relative overflow-hidden"
            >
              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-purple-500/20 h-full">
                <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>

                <div className="relative">

                  <div className="aspect-[4/4] rounded-xl overflow-hidden mb-6">
                    <img
                      src={"https://tsoministries.com/wp-content/uploads/2025/07/morningPrayer.jpg"}
                      alt="Zoom Invitation Image"
                      className="w-full h-full object-cover"
                    />
                  </div>

                  <h4 className="text-xl font-bold mb-0">PRAYER MEETING</h4>
                  <h4 className="text-md font-bold mb-1">with PASTOR TITOLUWA Olumideko</h4>
                  <p className="text-gray-500 mb-6">
                    Join us every morning by <span className='font-bold'>06:00 AM</span> @ zoom
                  </p>

                  <div className="flex gap-2 md:gap-4">
                    <motion.button
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      onClick={() => window.open("https://us06web.zoom.us/j/87232094712?pwd=P5qPJ9dAeeZKuEcQahKHbyO80olaAg.1", "_blank")}
                      className="px-4 md:px-6 py-2 bg-gradient-to-r from-purple-600 to-blue-600 rounded-lg text-white flex items-center gap-2"
                    >
                      <VideoIcon className="w-5 h-5" />
                      <span className='text-sm md:text-md'>Join Now</span>
                    </motion.button>
                    <motion.button
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      onClick={handleReminderClick}
                      className="px-4 md:px-6 py-2 bg-black/70 rounded-lg text-white flex items-center gap-2"
                    >
                      <AlarmCheck className="w-5 h-5" />
                      <span className='text-sm md:text-md'>Add Reminder to Calendar</span>
                    </motion.button>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Healing Party Section */}
            {/* <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="relative overflow-hidden"
            >
              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-pink-500/20 h-full">
                <div className="absolute top-0 right-0 w-64 h-64 bg-pink-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>

                <div className="flex items-center gap-4 mb-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-amber-600 to-pink-600 rounded-xl flex items-center justify-center">
                    <Map className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold">The Healing Party - Lagos</h3>
                </div>

                <div className="mb-6">
                  <p className="text-gray-400">
                    The Healing Party is a unique move of God where the Christ alone is taught,
                    worshipped, spoken of and as a result, miracles and signs take place.
                  </p>
                </div>

                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={() => window.location.href = "/gallery"}
                  className="w-full py-3 bg-gradient-to-r from-pink-600 to-amber-600 rounded-lg text-white flex items-center justify-center gap-2"
                >
                  <span>See What You Missed</span>
                  <ArrowRight className="w-5 h-5" />
                </motion.button>

                <div className="aspect-[4/3] rounded-xl overflow-hidden mb-6 mt-4">
                  <img
                    src={"https://tsoministries.com/wp-content/uploads/2025/07/thp_update.jpeg"}
                    alt="Walking in Divine Authority Book Cover"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="mb-0">
                  <p className="text-gray-400">
                    <span className='font-bold'>The-CONDO</span> Hosted by Pastor TitOluwa Olumideko <br />
                    VICTORIA ISLAND, LAGOS. - AUGUST 2025
                  </p>
                </div>

              </div>
            </motion.div> */}
          </div>
        </div>
      </section>

    </div>
  )
}





// const TestimonialsSection = () => {
//   const pinnedTestimonials = testimonials.filter(t => t.isPinned).slice(0, 2);
//   return (
//     <div className='flex justify-center items-center px-4 py-12 relative bg-white'>
//         <motion.section
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8, delay: 0.4 }}
//           className="mb-16"
//         >
//           <div className="flex items-center justify-between mb-8">
//             <div className="flex items-center">
//               <MessageCircle className="h-8 w-8 text-amber-500 mr-3" />
//               <h3 className="text-3xl font-bold text-blue-900">Featured Testimonials</h3>
//             </div>
//             <Link
//               to="/testimonials"
//               className="bg-amber-500 hover:bg-amber-600 text-white px-6 py-3 rounded-full font-medium transition-all duration-300 hover:shadow-lg hover:scale-105"
//             >
//               View All & Share Yours
//             </Link>
//           </div>

//           <div className="grid md:grid-cols-2 gap-8">
//             {pinnedTestimonials.map((testimonial, index) => (
//               <motion.div
//                 key={testimonial.id}
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.6, delay: 0.6 + index * 0.2 }}
//                 className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
//               >
//                 <div className="flex items-start justify-between mb-4">
//                   <div>
//                     <h4 className="font-semibold text-blue-900">{testimonial.author}</h4>
//                     <p className="text-amber-600 text-sm">{testimonial.ministry}</p>
//                   </div>
//                   <div className="flex items-center text-rose-500">
//                     <Heart className="h-4 w-4 mr-1" fill="currentColor" />
//                     <span className="text-sm">{testimonial.likes}</span>
//                   </div>
//                 </div>
//                 <p className="text-gray-700 leading-relaxed line-clamp-4">
//                   {testimonial.content}
//                 </p>
//                 <div className="mt-4 flex items-center justify-between">
//                   <span className="bg-amber-100 text-amber-800 px-3 py-1 rounded-full text-xs font-medium">
//                     Pinned
//                   </span>
//                   <span className="text-gray-500 text-xs">
//                     {testimonial.createdAt.toLocaleDateString()}
//                   </span>
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </motion.section>
//     </div>
//   )
// }
// const QuizSection = () => {
//   return (
//     <div className='flex justify-center items-center px-4 py-12 relative bg-gray-600'>
//       <motion.section
//         initial={{ opacity: 0, x: 20 }}
//         animate={{ opacity: 1, x: 0 }}
//         transition={{ duration: 0.8, delay: 0.8 }}
//       >
//         <div className="bg-gradient-to-r from-amber-400 to-amber-600 rounded-2xl p-8 text-white shadow-xl">
//           <div className="flex items-center justify-between">
//             <div>
//               <div className="flex items-center mb-4">
//                 <Brain className="h-8 w-8 text-white mr-3" />
//                 <h3 className="text-3xl font-bold">Weekly Growth Quiz</h3>
//               </div>
//               <p className="text-xl mb-6 text-amber-100">
//                 Test your biblical knowledge and track your spiritual growth journey
//               </p>
//               <div className="flex items-center text-amber-100 mb-6">
//                 <Users className="h-5 w-5 mr-2" />
//                 <span>Join 2,847 members this week</span>
//               </div>
//             </div>
//             <div className="hidden md:block">
//               <div className="bg-white/20 backdrop-blur-sm rounded-xl p-6 text-center">
//                 <div className="text-3xl font-bold mb-2">15</div>
//                 <div className="text-amber-100">Questions</div>
//               </div>
//             </div>
//           </div>
//           <Link
//             to="/quiz"
//             className="inline-flex items-center bg-white text-amber-600 px-8 py-4 rounded-full font-bold text-lg hover:shadow-lg transition-all duration-300 hover:scale-105"
//           >
//             Start Quiz Journey
//             <Brain className="ml-2 h-5 w-5" />
//           </Link>
//         </div>
//       </motion.section>
//     </div>
//   )
// }


const studyMaterials = [
  {
    title: "POP MY CHERRY NOW",
    format: "PDF",
    size: "2.5 MB",
    description: "This gives me such great joy to do. I remember going through vaginismus wondering if God knew I was married or maybe there was a certain heavenly form I needed to fill to open up the entry. I was confused. I never saw this coming.",
    image: "https://files.selar.co/product-images/2023/products/titoluwa-sam-oladapo1/pop-my-cherry-now-selar.co-650d1e3b5d3ef.jpeg",
    url: "https://selar.com/15293h"
  },
  {
    title: "FOCUS",
    format: "PDF",
    size: "2.5 MB",
    description: "What if becoming all God intended you to be starts with one simple act: looking? In FOCUS, you’ll discover the transformative power of spiritual sight—how the direction of your gaze determines the direction of your life. Rooted in biblical truth and filled with",
    image: "https://tsoministries.com/wp-content/uploads/2025/06/@titothewriter-focus.jpeg",
    url: "https://www.faveshq.com/home/product/682703ba39b95b01ce59612b/67ab79feda1bcd9b1ae76ee5/titothewriter"
  },
];
function Highlights() {
  return (
    <section className="relative py-24 bg-gradient-to-b from-black to-gray-900 text-white">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* Book Release Section */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative overflow-hidden"
          >
            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-purple-500/20 h-full">
              <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>

              <div className="relative">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-amber-600 to-pink-600 rounded-xl flex items-center justify-center">
                    <BookOpen className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold">New Book Release</h3>
                </div>

                <div className="aspect-[4/3] rounded-xl overflow-hidden mb-6">
                  <img
                    src={studyMaterials[1].image}
                    alt="Walking in Divine Authority Book Cover"
                    className="w-full h-full object-cover"
                  />
                </div>

                <h4 className="text-xl font-bold mb-3">{studyMaterials[1].title}</h4>
                <p className="text-gray-300 mb-6">
                  {studyMaterials[1].description}
                </p>

                <div className="flex gap-4">
                  <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => window.open(studyMaterials[1].url, "_blank")}
                    className="px-3 md:px-6 py-3 bg-gradient-to-r from-amber-600 to-pink-600 rounded-lg text-white flex items-center gap-2"
                  >
                    <Download className="w-5 h-5" />
                    <span className="text-sm md:text-md">Download Now</span>
                  </motion.button>
                  <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => window.open(studyMaterials[1].url, "_blank")}
                    className="px-3 md:px-6 py-3 bg-white/10 rounded-lg text-white flex items-center gap-2"
                  >
                    <span className="text-sm md:text-md">Learn More</span>
                    <ArrowRight className="w-5 h-5" />
                  </motion.button>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Event Highlight Section */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative overflow-hidden"
          >
            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-pink-500/20 h-full">
              <div className="absolute top-0 right-0 w-64 h-64 bg-pink-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>

              <div className="relative">
                <div className="mb-6">
                  <h3 className="text-2xl font-bold mb-2">Healing Party 2025</h3>
                  <p className="text-gray-400">
                    An unforgettable night of divine encounters, supernatural healing, and a powerful
                    outpouring of the Holy Spirit that transforms hearts and renews lives.
                  </p>
                </div>

                {/* <div className="grid grid-cols-2 gap-4 mb-6">
                  <div className="aspect-square rounded-xl overflow-hidden">
                    <img 
                      src="https://images.unsplash.com/photo-1519834089823-af2d966a0648"
                      alt="Healing Party Event"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="aspect-square rounded-xl overflow-hidden">
                    <img 
                      src="https://images.unsplash.com/photo-1501281668745-f7f57925c3b4"
                      alt="Healing Party Event"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div> */}
                <EventsHighlights parent="the_healing_party-ghana" noHeader />
                <div className='hidden md:block lg:block'>
                  <EventsHighlights parent="the_healing_party-ghana" noHeader />
                </div>

                <div className="bg-white/5 rounded-xl p-6 mb-6">
                  <div className="grid grid-cols-2 gap-4 text-center">
                    <div>
                      <div className="text-3xl font-bold text-orange-400">400+</div>
                      <div className="text-gray-400">Attendees</div>
                    </div>
                    <div>
                      <div className="text-3xl font-bold text-pink-400">100+</div>
                      <div className="text-gray-400">Testimonies</div>
                    </div>
                  </div>
                </div>

                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={() => window.location.href = "/gallery"}
                  className="w-full py-3 bg-gradient-to-r from-pink-600 to-amber-600 rounded-lg text-white flex items-center justify-center gap-2"
                >
                  <span>View Event Gallery</span>
                  <ArrowRight className="w-5 h-5" />
                </motion.button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}


const goToResource = (item) => {
  if (item.library_type === "bst") {
    window.location.href = `/study?id=${item.id}`;
  } else {
    window.open(item.youtube_url, "blank")
  }
}

function TeachingsSection() {
  const resources = useFetchYouTubeResources(videoLinks, audioLinks);
  const getRandomFeaturedResources = (resources) => {
    // Ensure we are picking from the latest resources
    const sortedResources = [...resources].sort((a, b) => b.publishedAt - a.publishedAt);

    // Separate videos and audios
    const videos = sortedResources.filter(resource => resource.type === "video");
    const audios = sortedResources.filter(resource => resource.type === "audio");

    // Pick 3 random videos
    const selectedVideos = videos.length > 3
      ? videos.sort(() => 0.5 - Math.random()).slice(0, 3)
      : videos; // If less than 3 videos, take all available

    // Pick 1 random audio
    const selectedAudio = audios.length > 0
      ? [audios[Math.floor(Math.random() * audios.length)]]
      : []; // If no audio, return empty array

    // Merge and return
    return [...selectedVideos, ...selectedAudio];
  };
  // const teachings = [];
  const teachings_ = useMemo(() => getRandomFeaturedResources(resources), [resources]);
  const [sortBy, setSortBy] = useState("newest")
  // const [teachings, setTeachings] = useState([]);
  const [sampleResources, setSampleResources] = useState([]);

  const teachings = useMemo(() => {
    const filtered = sampleResources.filter((resource) => {
      const matchesFeatured = resource.library_type === "bst"
      return matchesFeatured
    })

    // Sort resources
    filtered.sort((a, b) => {
      switch (sortBy) {
        case "newest":
          return new Date(b.date).getTime() - new Date(a.date).getTime()
        case "oldest":
          return new Date(a.date).getTime() - new Date(b.date).getTime()
        case "popular":
          return b.views - a.views
        case "rating":
          return b.rating - a.rating
        case "title":
          return a.title.localeCompare(b.title)
        default:
          return 0
      }
    })

    return filtered.slice(0, 4)
  }, [sampleResources, sortBy])

  useEffect(() => {
    const fetchAllLibrary = async () => {
      await fetchLibraryItems((currentList) => {
        setSampleResources(currentList); // Updates list as it loads
      });
    };

    fetchAllLibrary();
  }, []);



  return (
    <section className="relative py-20 overflow-hidden bg-white">
      {/* Background with subtle pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-50 to-white opacity-70"></div>
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1579546929518-9e396f3cc809?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80')] opacity-5 bg-cover bg-center"></div>
      <img className='absolute bottom-0 h-[30vw] w-[40vw] opacity-20' src={ImagesDev.futuristic_pattern} style={{ objectFit: "cover" }} />
      <img className='absolute top-0 right-0 h-[20vw] w-[40vw] opacity-20 rotate-[180deg]' src={ImagesDev.futuristic_pattern} style={{ objectFit: "cover" }} />

      <div className="container mx-auto px-4 relative z-10 max-w-6xl">
        <div className="flex flex-col items-center mb-16 text-center">
          <div className="inline-flex items-center justify-center p-2 bg-indigo-100 rounded-full mb-4">
            <BookOpenIcon className="text-amber-600 w-6 h-6" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 tracking-tight mb-4">
            Dive Into Christ-Centered Teachings
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl">
            Gain deep insights into the Word of God with these powerful teachings.
            Each message is designed to transform your understanding and deepen your faith.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8">
          {teachings.map((teaching) => (
            <div key={teaching.id} className="group relative">
              <div className="absolute -inset-0.5 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-2xl blur opacity-25 group-hover:opacity-100 transition duration-500 group-hover:duration-200"></div>
              <a
                // href={teaching.link}
                // target={"_blank"}
                onClick={() => goToResource(teaching)}
                className="relative block bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 h-[400px]"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={teaching.thumbnail}
                    alt={teaching.title}
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute bottom-4 left-4 right-4 transform translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                    <div className="flex items-center gap-2">
                      <div className="bg-orange-600 p-2 rounded-full">
                        <Play className="w-4 h-4 text-white" />
                      </div>
                      <span className="text-white text-sm font-medium">Watch Now</span>
                    </div>
                  </div>
                </div>

                <div className="p-4 md:p-5">
                  <div className="flex flex-col justify-between mb-1 md:mb-2">
                    <div className="flex items-center text-gray-400 text-[10px] md:text-xs p-1 md:p-0">
                      <Clock className="w-3 h-3 mr-1" />
                      {teaching.duration}
                    </div>
                    <span className="text-[10px] font-medium text-indigo-600 bg-indigo-50 px-2.5 py-0.5 rounded-md md:rounded-full">
                      {/* {teaching.speaker} */}
                      Pst. TitOluwa Olumideko
                    </span>
                  </div>
                  <h3 className="text-md md:text-xl font-bold text-gray-900 mb-2 group-hover:text-orange-600 transition-colors duration-300">
                    {/* {teaching.title} */}
                    {teaching.title.slice(0, 40)}{teaching.title.length >= 40 ? "..." : ""}
                  </h3>
                  {/* <p className="text-gray-600 text-xs md:text-sm mb-4">
                    {teaching.description.slice(0, 50)}{teaching.description.length >= 50 ? "..." : ""}
                  </p> */}
                </div>
              </a>
            </div>
          ))}
        </div>

        <div className="mt-16 flex flex-col md:flex-row items-center justify-center gap-4">
          <a
            href="https://www.youtube.com/@titothewriter"
            target={"_blank"}
            className="flex items-center px-6 py-3 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 transition duration-300 shadow-lg hover:shadow-red-500/20 w-full md:w-auto justify-center"
          >
            <Youtube className="mr-2 w-5 h-5" /> Stream on Youtube
          </a>
          <a
            href="/library"
            className="flex items-center px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 transition duration-300 shadow-lg hover:shadow-indigo-500/20 w-full md:w-auto justify-center"
          >
            View Full Collection <ChevronRight className="ml-1 w-4 h-4" />
          </a>
        </div>

        <div className="mt-16 bg-gradient-to-r from-indigo-100 to-purple-100 rounded-2xl p-8 shadow-lg">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="bg-white p-4 rounded-full shadow-md">
              <BookOpenIcon className="w-10 h-10 text-amber-600" />
            </div>
            <div className="flex-1 text-center md:text-left">
              <h4 className="text-xl font-bold text-gray-900 mb-2">Weekly Bible Study</h4>
              <p className="text-gray-600">Join our weekly online Bible study sessions for deeper insights and community discussion.</p>
            </div>
            <a
              href="/register"
              className="px-6 py-3 bg-gradient-to-r from-amber-600 to-orange-600 text-white font-medium rounded-lg hover:from-indigo-700 hover:to-purple-700 transition duration-300 shadow-lg hover:shadow-indigo-500/20 whitespace-nowrap"
            >
              Register Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function IntroCarousel() {
  return (
    <div className='relative bg-white'>
      <img className='absolute bottom-0 h-[30vw] w-[40vw] opacity-20' src={ImagesDev.futuristic_pattern} style={{ objectFit: "cover" }} />
      <img className='absolute bottom-[20vw] left-0 h-[20vw] w-[40vw] opacity-20 ' src={ImagesDev.futuristic_pattern} style={{ objectFit: "cover" }} />

      {/* RTURN THIS SECTION BACK AFTER EVEN - WHEN RESTRUCTURUNG */}
      {/* <div className="max-w-3xl mx-auto mb-0 p-10">
        {[
          { text: 'TILL EVERY EYE,', class: "text-5xl font-light italic mb-4 pt-10 fonseca" },
          { text: 'SEES JESUS.', class: "text-5xl font-light italic mb-4 fonseca-bold" },
          { text: '"A ministry built on faith, love, and purpose. Dedicated to raising leaders, spreading truth, and igniting a lasting change in the world."', class: "text-2xl italic mb-12" }
        ].map((val, index) => {
          return (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <h2 className={val.class}>
                {val.text}
                {index === 2 &&
                  <span className='relative text-xl text-orange-400 cursor-pointer' onClick={() => window.location.href = "/about"}> Read More ...</span>}
              </h2>
            </motion.div>
          )
        })}
      </div> */}

      <EmblaCarousel slides={ImagesDev.SLIDE2} options={OPTIONS} />

    </div>
  )
}

function Slider_component() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [direction, setDirection] = useState(0); // -1 for prev, 1 for next, 0 for initial

  const nextSlide = useCallback(() => {
    setDirection(1);
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  }, [slides.length]);

  const prevSlide = useCallback(() => {
    setDirection(-1);
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  }, [slides.length]);

  useEffect(() => {
    const interval = setInterval(nextSlide, 7000);
    return () => clearInterval(interval);
  }, [nextSlide]);

  return (
    <section className="relative py-10 overflow-hidden bg-gradient-to-b from-gray-900 to-black">

      <div className="absolute inset-0 w-full h-full ">
        {slides.map((slide, index) => (
          <motion.div
            key={slide.id}
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: `url(${slide.image})` }}
            animate={{ opacity: index === currentSlide ? 0.15 : 0 }}
            transition={{ duration: 0.5 }}
          />
        ))}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 to-black/60 backdrop-blur-lg" />
      </div>

      <div className="container mx-auto px-4 relative z-10 max-w-7xl">
        <div className="flex flex-col items-center mb-8 text-center">
          <div className="inline-flex items-center justify-center p-2 bg-orange-900/30 rounded-full mb-4 border border-purple-500/30">
            <Calendar className="text-orange-400 w-6 h-6" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white tracking-tight mb-4">
            Events Gallery
          </h2>
          <p className="text-lg text-orange-200/80 max-w-3xl">
            Catch up on Past Events, and don't miss out on Upcoming Events
          </p>
        </div>

        <div className="relative max-w-6xl mx-auto">

          {/* Main slider container */}
          <div className="relative overflow-hidden rounded-2xl shadow-2xl shadow-purple-900/20 bg-gradient-to-r from-gray-900 to-gray-800 border border-gray-700/50">
            <div className="flex flex-col lg:flex-row h-[800px] sm:h-auto sm:min-h-[500px]">
              {/* Left content panel */}
              <div className="w-full lg:w-1/2 p-8 md:p-12 lg:p-16 flex flex-col justify-center relative overflow-hidden order-2 lg:order-1">
                <AnimatePresence mode="wait">
                  <motion.div
                    key={`content-${currentSlide}`}
                    initial={{
                      opacity: 0,
                      x: direction >= 0 ? 50 : -50
                    }}
                    animate={{
                      opacity: 1,
                      x: 0
                    }}
                    exit={{
                      opacity: 0,
                      x: direction >= 0 ? -50 : 50
                    }}
                    transition={{
                      duration: 0.5,
                      ease: easeInOut
                    }}
                    className="relative z-10"
                  >
                    <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 mb-6">
                      <Calendar className="w-4 h-4 text-orange-300" />
                      <span className="text-sm font-medium text-orange-200">{slides[currentSlide].date}</span>
                    </div>

                    <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 leading-tight">
                      {slides[currentSlide].title}
                    </h2>

                    <div className="flex items-center gap-2 mb-6">
                      <MapPin className="w-4 h-4 text-orange-300 flex-shrink-0" />
                      <span className="text-sm text-orange-200">{slides[currentSlide].location}</span>
                    </div>

                    <p className="text-gray-300 mb-8 leading-relaxed">
                      {slides[currentSlide].description}
                    </p>

                    <div className="flex flex-wrap gap-4">
                      <a
                        href={slides[currentSlide].url}
                        className={`inline-flex items-center px-6 py-3 bg-amber-600 ${slides[currentSlide].activeColor} hover:bg-orange-700 text-white font-medium rounded-lg transition-all duration-300 shadow-lg shadow-purple-900/30 hover:shadow-purple-900/50`}
                      >
                        Event Details
                        <ArrowRight className="ml-2 w-4 h-4" />
                      </a>
                      <a
                        href="#register"
                        className="inline-flex items-center px-6 py-3 bg-transparent hover:bg-white/10 text-white border border-orange-500/50 hover:border-orange-400 font-medium rounded-lg transition-all duration-300"
                      >
                        Register Now
                      </a>
                    </div>
                  </motion.div>
                </AnimatePresence>

                {/* Decorative elements */}
                <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-orange-600/20 to-transparent rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
                <div className="absolute bottom-0 left-0 w-64 h-64 bg-gradient-to-tr from-blue-600/10 to-transparent rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>
              </div>

              {/* Right image panel */}
              <div className="w-full lg:w-1/2 relative h-[300px] md:h-[400px] lg:h-auto overflow-hidden order-1 lg:order-2">
                {/* Navigation buttons */}
                <div className="absolute left-4 right-4 top-4 flex justify-between z-20">
                  <div className="flex gap-2">
                    {slides.map((_, index) => (
                      <button
                        key={`dot-${index}`}
                        onClick={() => {
                          setDirection(index > currentSlide ? 1 : -1);
                          setCurrentSlide(index);
                        }}
                        className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${index === currentSlide
                          ? "bg-white scale-125"
                          : "bg-white/40 hover:bg-white/60"
                          }`}
                        aria-label={`Go to slide ${index + 1}`}
                      />
                    ))}
                  </div>

                  <div className="flex gap-2">
                    <button
                      onClick={prevSlide}
                      className="p-2 rounded-full bg-black/20 hover:bg-black/40 backdrop-blur-sm transition-colors border border-white/10 hover:border-white/20"
                      aria-label="Previous slide"
                    >
                      <ChevronLeft className="w-5 h-5 text-white" />
                    </button>
                    <button
                      onClick={nextSlide}
                      className="p-2 rounded-full bg-black/20 hover:bg-black/40 backdrop-blur-sm transition-colors border border-white/10 hover:border-white/20"
                      aria-label="Next slide"
                    >
                      <ChevronRight className="w-5 h-5 text-white" />
                    </button>
                  </div>
                </div>

                {/* Images */}
                <AnimatePresence initial={false}>
                  <motion.div
                    key={`image-${currentSlide}`}
                    className="absolute inset-0"
                    initial={{
                      opacity: 0,
                      scale: 1.1,
                    }}
                    animate={{
                      opacity: 1,
                      scale: 1,
                    }}
                    exit={{
                      opacity: 0,
                      scale: 0.95,
                    }}
                    transition={{
                      duration: 0.7,
                      ease: easeInOut
                    }}
                  >
                    <div className="relative w-full h-full">
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/30 z-10" />
                      <img
                        src={slides[currentSlide].image}
                        alt={slides[currentSlide].title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </motion.div>
                </AnimatePresence>
              </div>
            </div>
          </div>

          {/* Progress bar */}
          <div className="left-0 right-0 flex gap-2 justify-center mt-8">
            {slides.map((_, index) => (
              <button
                key={`indicator-${index}`}
                onClick={() => {
                  setDirection(index > currentSlide ? 1 : -1);
                  setCurrentSlide(index);
                }}
                className="group relative h-1 rounded-full overflow-hidden transition-all duration-300"
                style={{ width: index === currentSlide ? '3rem' : '1.5rem' }}
              >
                <div className="absolute inset-0 bg-white/30 group-hover:bg-white/50 transition-colors duration-300"></div>
                {index === currentSlide && (
                  <motion.div
                    className="absolute inset-0 bg-orange-500"
                    initial={{ width: "0%" }}
                    animate={{ width: "100%" }}
                    transition={{ duration: 7, ease: "linear" }}
                    key={currentSlide}
                  />
                )}
              </button>
            ))}
          </div>

          {/* Bottom navigation */}
          {/* <div className="flex justify-center mt-10">
            <div className="flex gap-3">
              <button
                onClick={prevSlide}
                className="p-3 rounded-full bg-white/5 hover:bg-white/10 backdrop-blur-sm transition-all duration-300 border border-white/10 hover:border-purple-400/30 group"
                aria-label="Previous slide"
              >
                <ChevronLeft className="w-5 h-5 text-white group-hover:text-purple-300 transition-colors" />
              </button>
              <button
                onClick={nextSlide}
                className="p-3 rounded-full bg-white/5 hover:bg-white/10 backdrop-blur-sm transition-all duration-300 border border-white/10 hover:border-purple-400/30 group"
                aria-label="Next slide"
              >
                <ChevronRight className="w-5 h-5 text-white group-hover:text-purple-300 transition-colors" />
              </button>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}

function AboutMinisters() {
  const ministers = [
    { id: 1, name: "Dr. Flourish Peters", role: "Speaker", image: ImagesDev.ministers.pflo },
    { id: 3, name: "Pastor Lanre Olubaji", role: "Speaker", image: ImagesDev.ministers.pLanre },
    { id: 4, name: "Pastor Noble G.", role: "Speaker", image: ImagesDev.ministers.png },
    { id: 2, name: "Min. Mag Psalms", role: "Speaker", image: ImagesDev.ministers.magPsalm },
  ];

  const host = {
    name: "Pst. TitOluwa Olumideko",
    role: "Host & Lead Pastor",
    // image: ImagesDev.ministers.minTSO,
    image: "https://tsoministries.com/wp-content/uploads/2025/06/IMG_2869-.jpg"
  };

  return (
    <section className="relative py-20 bg-gradient-to-b from-white to-gray-200 overflow-hidden">
      {/* <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1511367461989-f85a21fda167?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80')] opacity-10 bg-cover bg-center"></div> */}
      <div className='absolute top-0 left-0 w-full h-full opacity-50' style={{ background: `url(${ImagesDev.bg1_postOfTheDay}) center`, backgroundSize: "cover" }} />

      <div className="container mx-auto px-4 relative z-10 max-w-6xl">

        <div className="text-center lg:mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">Our Ministry's Head</h2>
          <div className="h-1 w-24 bg-gradient-to-r from-orange-400 to-amber-400 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-start">
          {/* Host - Featured */}
          <div className="lg:col-span-2 order-2 lg:order-1">
            <div className="relative group">
              <div className="absolute -inset-1 bg-gradient-to-r from-orange-600 to-gray-600 rounded-2xl blur opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
              <div className="relative bg-gray-900 rounded-xl overflow-hidden">
                <img
                  src={host.image}
                  alt={host.name}
                  className="w-full aspect-[5/4] sm:aspect-[6/4] md:aspect-[6/4] lg:aspect-[3/4] object-cover object-center"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent pt-20 pb-6 px-6">
                  <div className="flex items-center gap-2 mb-1">
                    <Mic2 className="w-5 h-5 text-orange-400" />
                    <p className="text-orange-300 font-medium">{host.role}</p>
                  </div>
                  <h3 className="text-2xl font-bold text-white">{host.name}</h3>
                </div>
              </div>
            </div>
            <div className="grid lg:hidden grid-cols-2 md:grid-cols-2 gap-6 mt-8 md:mt-8 lg:mt-0">
              {socialLinks_.map((social, index) => (
                <motion.a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className={`flex items-center space-x-4 bg-black/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 ${social.color} transition-colors duration-300`}
                >
                  <social.icon className="w-6 h-6" />
                  <div>
                    <p className="font-medium">{social.platform}</p>
                    <p className="text-sm text-gray-400">{social.handle}</p>
                  </div>
                  <ExternalLink className="w-4 h-4 ml-auto" />
                </motion.a>
              ))}
            </div>
          </div>

          {/* Ministers List */}
          <div className="lg:col-span-3 order-1 lg:order-2 space-y-6 flex flex-col-reverse md:flex-col">

            <div className="mt-8 bg-gray-900/20 backdrop-blur-sm border border-orange-800/30 rounded-lg p-6">
              <h4 className="text-xl font-semibold text-black mb-3">Meet Titoluwa TitoTheWriter Olumideko</h4>
              <p className="text-gray-800">
                TitOluwa Olumideko, widely known as TitotheWriter or the Jesus Brand Influencer,
                is an ordained Pastor, a seasoned writer, and an audacious preacher with a steadfast
                commitment to the gospel of Christ.
              </p>
              <p className="text-gray-800 py-3 pb-6">
                As the visionary leader of TSO Ministries and its subsidiaries, she is devoted to
                breaking the shackles of religion and presenting the truth of Jesus with clarity and conviction.
              </p>
              <Link to={"/titothewriter"} className={"p-2 bg-slate-600 rounded-lg text-white"}>read more</Link>
            </div>

            <div className="hidden lg:grid grid-cols-2 md:grid-cols-2 gap-6 mt-8 md:mt-0">
              {socialLinks_.map((social, index) => (
                <motion.a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className={`flex items-center space-x-4 bg-black/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 ${social.color} transition-colors duration-300`}
                >
                  <social.icon className="w-6 h-6" />
                  <div>
                    <p className="font-medium">{social.platform}</p>
                    <p className="text-sm text-gray-400">{social.handle}</p>
                  </div>
                  <ExternalLink className="w-4 h-4 ml-auto" />
                </motion.a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}



function App_countdown() {
  // Set the target date (28 February 2025, 6:00 PM Nigerian time)
  // Set the target date (30 August 2025, 9:00 AM Nigerian time)
  const targetDate = new Date("2026-08-28T14:00:00+01:00");

  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [animatedValues, setAnimatedValues] = useState({ days: 100, hours: 100, minutes: 100, seconds: 100 });
  const countdownRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [animationComplete, setAnimationComplete] = useState(false);
  const [eventPassed, setEventPassed] = useState(false);

  // useEffect(() => {
  //   const calculateTimeLeft = () => {
  //     const difference = +targetDate - +new Date();
  //     if (difference < 0) {
  //       setEventPassed(true);
  //       return {
  //         days: 0,
  //         hours: 0,
  //         minutes: 0,
  //         seconds: 0
  //       };
  //     }
  //     return {
  //       days: Math.floor(difference / (1000 * 60 * 60 * 24)),
  //       hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
  //       minutes: Math.floor((difference / 1000 / 60) % 60),
  //       seconds: Math.floor((difference / 1000) % 60),
  //     };
  //   };

  //   const updateTimeLeft = () => {
  //     setTimeLeft(calculateTimeLeft());
  //   };

  //   updateTimeLeft(); // Initial calculation
  //   const timer = setInterval(updateTimeLeft, 1000);
  //   return () => clearInterval(timer);
  // }, [targetDate]);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = +targetDate - +new Date();
      if (difference < 0) {
        setEventPassed(true);
        return {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        };
      }
      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    };

    const updateTimeLeft = () => {
      setTimeLeft(calculateTimeLeft());
    };

    updateTimeLeft(); // Initial calculation
    const timer = setInterval(updateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (countdownRef.current) {
      observer.observe(countdownRef.current);
    }

    return () => {
      if (countdownRef.current) {
        observer.unobserve(countdownRef.current);
      }
    };
  }, [isVisible]);

  useEffect(() => {
    if (isVisible && !animationComplete) {
      setAnimationComplete(true); // Ensure animation runs only once

      const animateCountdown = (key, value) => {
        let current = 100;
        const step = (100 - value) / 30; // Adjust speed here

        const countdownInterval = setInterval(() => {
          setAnimatedValues((prev) => {
            let newValue = Math.max(prev[key] - step, value);
            return { ...prev, [key]: Math.floor(newValue) };
          });

          if (current <= value) {
            clearInterval(countdownInterval);
          }

          current -= step;
        }, 50);
      };

      // Animate only for days, hours, and minutes (not seconds)
      Object.keys(timeLeft).forEach((key) => {
        if (key !== "seconds") {
          animateCountdown(key, timeLeft[key]);
        }
      });

      // Set seconds to update dynamically
      setAnimatedValues((prev) => ({ ...prev, seconds: timeLeft.seconds }));
    }
  }, [isVisible, timeLeft, animationComplete]);

  // Update seconds in real-time
  useEffect(() => {
    if (animationComplete) {
      setAnimatedValues((prev) => ({ ...prev, seconds: timeLeft.seconds }));
    }
  }, [timeLeft.seconds, animationComplete]);

  const returnTimeName = (value, singular) => {
    return value === 1 ? singular : singular + "s";
  };

  return (
    <section className="hidden md:grid relative py-10 pt-10 overflow-hidden bg-black bg-opacity-70 backdrop-blur-lg">
      {/* Hero Section with Parallax Effect */}
      {/* <div className="relative h-[50vh] overflow-hidden">
        <motion.div
          className="absolute inset-0 w-full h-full"
          initial={{ scale: 1.1 }}
          whileInView={{ scale: 1 }}
          transition={{ duration: 1.5 }}
          viewport={{ once: true }}
        >
          <div
            className="absolute inset-0 w-full h-full bg-cover bg-center"
            style={{ backgroundImage: `url(https://tsoministries.com/wp-content/uploads/2026/08/THP26-Updated-scaled.png)` }}
          ></div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/80"></div>
        </motion.div>

        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="mb-6 pt-16"
          >
            <h2 className="text-4xl md:text-6xl font-bold text-white mb-4">
              <span className="text-transparent bg-clip-text bg-gradient-to-b from-amber-500 to-white-600">
                The Healing Party
              </span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Experience the transformative power of God's presence
            </p>
          </motion.div>

          <motion.div
            animate={{
              y: [0, -10, 0],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: easeInOut,
            }}
            className="text-white text-2xl md:text-3xl font-bold pt-20"
          >
            {eventPassed ? "You missed this?" : "Happening Soon"}
            <div className="mt-2">
              <ArrowDown size={26} className="mx-auto text-orange-400" />
            </div>
          </motion.div>
        </div>
      </div> */}

      {/* Countdown Section */}

      <motion.div
        className="absolute inset-0 w-full h-full"
        initial={{ scale: 1.1 }}
        whileInView={{ scale: 1 }}
        transition={{ duration: 1.5 }}
        viewport={{ once: true }}
      >
        <div
          className="absolute inset-0 w-full h-full bg-cover bg-center blur-sm opacity-40"
          style={{ backgroundImage: `url(https://tsoministries.com/wp-content/uploads/2026/08/THP26-Updated-scaled.png)` }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/80"></div>
      </motion.div>

      <div
        ref={countdownRef}
        className="relative py-20"
      >

        <div className="container mx-auto text-center px-4 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="mb-6"
          >
            <h2 className="text-4xl md:text-6xl font-bold text-white mb-4">
              <span className="text-transparent bg-clip-text bg-gradient-to-b from-pink-600 to-white-600">
                The Healing Party
              </span>
            <div className="h-1 w-24 bg-gradient-to-r from-orange-400 to-pink-400 mx-auto mt-3"></div>
            </h2>
          </motion.div>

          <motion.div
            animate={{
              y: [0, -10, 0],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: easeInOut,
            }}
            className="text-white text-2xl md:text-3xl font-bold"
          >
            {eventPassed ? "Event Has Ended" : "Countdown to the Event"}
            <div className="mt-2">
              <ArrowDown size={26} className="mx-auto text-orange-400" />
            </div>
          </motion.div>

          {/* <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              {eventPassed ? "Event Has Ended" : "Countdown to the Event"}
            </h2>
          </motion.div> */}

          <div className="max-w-5xl mx-auto">
            {/* Countdown Boxes */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-16">
              {[
                { value: animatedValues.days, label: "Day", icon: <Calendar className="w-6 h-6 text-orange-300" /> },
                { value: animatedValues.hours, label: "Hour", icon: <Clock className="w-6 h-6 text-orange-300" /> },
                { value: animatedValues.minutes, label: "Minute", icon: <Timer className="w-6 h-6 text-orange-300" /> },
                { value: timeLeft.seconds, label: "Second", icon: <div className="w-6 h-6 flex items-center justify-center text-orange-300 font-bold">S</div> },
              ].map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="relative group"
                >
                  <div className="absolute -inset-0.5 bg-gradient-to-r from-orange-500 to-pink-500 rounded-3xl opacity-20 transition duration-300"></div>
                  <div className="relative bg-gray-900 bg-opacity-90 backdrop-blur-lg rounded-3xl p-6 md:p-8 text-center h-full flex flex-col items-center justify-center border border-purple-500/20">
                    <div className="mb-3 opacity-80">{item.icon}</div>
                    <div className="text-4xl md:text-6xl font-bold text-white mb-2 font-mono">
                      {item.value < 10 ? `0${item.value}` : item.value}
                    </div>
                    <div className="text-sm text-orange-200 uppercase tracking-wider">
                      {returnTimeName(item.value, item.label)}
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>

            <div className='w-full flex justify-center'>
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => eventPassed ? window.location.href = "/gallery" : window.location.href = "/healing-party"}
                className="w-[40vw] py-3 mb-6 bg-gradient-to-r from-pink-600 to-amber-600 rounded-lg text-white flex items-center justify-center gap-2"
              >
                <span>{eventPassed ? "See What You Missed" : "Register Now"}</span>
                <ArrowRight className="w-5 h-5" />
              </motion.button>
            </div>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Experience the transformative power of God's presence
            </p>

            {/* Info Cards - Only Visible when there is an Event */}
            {/* <div className="grid md:grid-cols-2 gap-8 mt-12">
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
                className="relative group"
              >
                <div className="absolute -inset-0.5 bg-gradient-to-r from-orange-500 to-grey-500 rounded-xl blur opacity-30 group-hover:opacity-60 transition duration-300"></div>
                <div className="absolute -inset-0.5  bg-gray-900 bg-opacity-80 backdrop-blur-lg rounded-lg border border-orange-500/20"></div>
                <div className="relative p-6">
                  <div className="flex items-center gap-4 mb-4">
                    <div className="p-3 bg-orange-900/50 rounded-full">
                      <Timer className="w-6 h-6 text-orange-300" />
                    </div>
                    <h3 className="text-xl font-semibold text-white">
                      {eventPassed ? "The Countdown has ended" : "The Countdown is On"}
                    </h3>
                  </div>
                  <p className="text-gray-300 leading-relaxed">
                    "<span className="font-bold text-orange-300">Life in the Spirit,</span> Life in your full christ potential.
                    Life gives you infinite possibilities to fail — but at
                    the same time, it gives you infinite possibilities to succeed and experience God's power."
                  </p>
                  
                  {!eventPassed && (
                    <div className="mt-6">
                      <a 
                        href="#register" 
                        className="inline-flex items-center px-5 py-2.5 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-medium rounded-lg hover:from-purple-700 hover:to-pink-700 transition-all duration-300 shadow-lg hover:shadow-purple-500/30"
                      >
                        Register Now
                        <ArrowRight className="ml-2 w-4 h-4" />
                      </a>
                    </div>
                  )}
                </div>
              </motion.div>
              
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <EventLocation />
              </motion.div>
            </div> */}
          </div>
        </div>

        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-purple-600/20 to-transparent rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-gradient-to-tr from-blue-600/20 to-transparent rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>
      </div>

    </section>
  );
}

function Mobile_section1() {
  // Set the target date (28 February 2025, 6:00 PM Nigerian time)
  // Set the target date (30 August 2025, 9:00 AM Nigerian time)
  const targetDate = new Date("2026-08-28T14:00:00+01:00");
  const [eventPassed, setEventPassed] = useState(false);

  useEffect(() => {
    const isEventPassed = () => {
      const difference = +targetDate - +new Date();
      if (difference < 0) {
        setEventPassed(true);
        return true
      }
      return true
    };

    isEventPassed(); // Initial calculation
    return () => { };
  }, [targetDate]);


  return (
    <div className='flex md:hidden bg-cover bg-center' style={{ backgroundImage: `url(${ImagesDev.MobileBG})` }}>
      <div className="relative w-screen overflow-hidden">
        {/* Section Gradient Background */}
        <div className='absolute top-0 left-0 w-full h-full ' style={{ backdropFilter: "blur(10px)" }}>
          <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-black/20 scale-[2] opacity-60" />
        </div>

        <div className="relative w-screen">
          <div className='relative top-0 h-full w-full zIndex-1 pt-4' style={{ display: "flex", flexDirection: "column", alignContent: "flex-end" }}>
            {/* <motion.p
              className="px-10 absolute top-[10px] -left-5"
              style={{ color: "white", textAlign: "center", fontSize: 10 }}
              animate={{
                y: [4, -6, 4],
              }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: easeInOut,
              }}
            >
              {eventPassed ? "You Missed this?" : "Happening Soon"} <ArrowDown size={16} />
            </motion.p> */}

            <div className="w-full flex flex-row pt-5 px-2">
              <div className="relative inset-0 w-[100vw] h-[200px] bg-cover bg-center overflow-hidden"
                style={{ borderRadius: 13, margin: "1vw" }}
              >
                <motion.div
                  className="absolute inset-0 w-full h-full"
                  initial={{ scale: 1.1 }}
                  whileInView={{ scale: 1 }}
                  transition={{ duration: 1.5 }}
                  viewport={{ once: true }}
                >
                  <div
                    className="absolute inset-0 w-full h-full bg-cover bg-center"
                    style={{ backgroundImage: `url(https://tsoministries.com/wp-content/uploads/2026/08/THP26-Updated-scaled.png)` }}
                  ></div>
                  <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/50 to-black/80"></div>
                </motion.div>

                <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
                  <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    className="mb-6"
                  >
                    <h2 className="text-4xl md:text-6xl font-bold text-white mb-0">
                      <span className="text-transparent bg-clip-text bg-gradient-to-b from-pink-500 to-white-600">
                        The Healing Party
                      </span>
                    </h2>
                    {/* <p className="text-md text-gray-300 max-w-3xl mx-auto opacity-30">
                      Experience the transformative power of God's presence
                    </p> */}
                  </motion.div>

                  <motion.div
                    animate={{
                      y: [0, -10, 0],
                    }}
                    transition={{
                      duration: 2,
                      repeat: Infinity,
                      ease: easeInOut,
                    }}
                    className="text-white text-2xl md:text-3xl font-bold"
                  >
                    {eventPassed ? "You missed this?" : "Happening Soon"}
                    <div className="mt-2">
                      <ArrowDown size={26} className="mx-auto text-orange-400" />
                    </div>
                  </motion.div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Section Content */}
        <div className='relative top-0 h-full w-full zIndex-1 py-5 flex flex-col items-center' style={{ display: "flex", flexDirection: "column", alignContent: "flex-end" }}>

          {eventPassed ?
            <p className="text-2xl italic mb-0 text-white px-5 text-center">
              "<span className='font-bold'>Event has ended</span>"</p>
            :
            <p className="text-2xl italic mb-0 text-white px-5 text-center">
              "<span className='font-bold'>Countdown to the Event</span>"</p>
          }
          <div className="h-1 w-24 bg-gradient-to-r from-orange-400 to-pink-400 mx-auto mb-6 mt-3"></div>
          <App_countdown_Mobile targetDate={targetDate} />

          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => eventPassed ? window.location.href = "/gallery" : window.location.href = "/healing-party"}
            className="w-[60vw] py-3 mb-6 bg-gradient-to-r from-pink-600 to-amber-600 rounded-lg text-white flex items-center justify-center gap-2"
          >
            <span>{eventPassed ? "See What You Missed" : "Register Now"}</span>
            <ArrowRight className="w-5 h-5" />
          </motion.button>
          {/* <a href='/ministries/life-in-the-spirit' className='text-1xl italic mb-1 text-white px-5 flex items-center justify-center text-center'>read more <ArrowRight size={12} /></a> */}
        </div>
      </div>
    </div>
  )
}
function App_countdown_Mobile({ targetDate }) {

  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [animatedValues, setAnimatedValues] = useState({ days: 100, hours: 100, minutes: 100, seconds: 100 });
  const countdownRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [animationComplete, setAnimationComplete] = useState(false);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = +targetDate - +new Date();
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      }
    };

    calculateTimeLeft(); // Initial calculation
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
        }
      },
      { threshold: 0.5 }
    );

    if (countdownRef.current) {
      observer.observe(countdownRef.current);
    }

    return () => {
      if (countdownRef.current) {
        observer.unobserve(countdownRef.current);
      }
    };
  }, [isVisible]);

  useEffect(() => {
    if (isVisible && !animationComplete) {
      setAnimationComplete(true); // Ensure animation runs only once

      const animateCountdown = (key, value) => {
        let current = 100;
        const step = (100 - value) / 30; // Adjust speed here

        const countdownInterval = setInterval(() => {
          setAnimatedValues((prev) => {
            let newValue = Math.max(prev[key] - step, value);
            return { ...prev, [key]: Math.floor(newValue) };
          });

          if (current <= value) {
            clearInterval(countdownInterval);
          }

          current -= step;
        }, 50);
      };

      // Animate only for days, hours, and minutes (not seconds)
      Object.keys(timeLeft).forEach((key) => {
        if (key !== "seconds") {
          animateCountdown(key, timeLeft[key]);
        }
      });

      // Set seconds to update dynamically
      setAnimatedValues((prev) => ({ ...prev, seconds: timeLeft.seconds }));
    }
  }, [isVisible, timeLeft.seconds]);

  const returnTimeName = (value, singular) => {
    return value === 1 ? singular : singular + "s";
  };

  return (
    <div className="container mx-auto px-4 text-white">
      <div ref={countdownRef} className="max-w-4xl mx-auto">
        <div className="grid grid-cols-4 gap-4 mb-6">
          {[
            { value: animatedValues.days, label: "Day", icon: <Calendar className="w-4 h-4 text-orange-300" /> },
            { value: animatedValues.hours, label: "Hour", icon: <Clock className="w-4 h-4 text-orange-300" /> },
            { value: animatedValues.minutes, label: "Minute", icon: <Timer className="w-4 h-4 text-orange-300" /> },
            { value: timeLeft.seconds, label: "Second", icon: <div className="w-4 h-4 text-md flex items-center justify-center text-orange-300 font-bold">S</div> },
          ].map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="relative group"
            >
              <div className="absolute -inset-0.5 bg-gradient-to-r from-orange-500 to-pink-500 rounded-3xl opacity-20 transition duration-300"></div>
              <div className="relative bg-gray-900 bg-opacity-90 backdrop-blur-lg rounded-3xl p-6 md:p-8 text-center h-full flex flex-col items-center justify-center border border-purple-500/20">
                <div className="mb-3 opacity-80">{item.icon}</div>
                <div className="text-4xl md:text-6xl font-bold text-white mb-2 font-mono">
                  {item.value < 10 ? `0${item.value}` : item.value}
                </div>
                <div className="text-xs text-orange-200 uppercase tracking-wider">
                  {returnTimeName(item.value, item.label)}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}












export default Home;


//Don't Delete this function 👇
function EventLocation() {
  const eventLatitude = 6.5708;
  const eventLongitude = 3.3651;

  const openGoogleMaps = () => {
    const googleMapsURL = `https://www.google.com/maps/dir/?api=1&destination=${eventLatitude},${eventLongitude}`;
    window.open(googleMapsURL, "_blank"); // Open in new tab
  };

  return (
    <div className="relative group h-full">
      <div className="absolute -inset-0.5 bg-gradient-to-r from-gray-500 to-orange-500 rounded-xl opacity-30 group-hover:opacity-60 transition duration-300"></div>
      <div className="relative bg-gray-900 bg-opacity-80 backdrop-blur-lg rounded-lg p-6 border border-blue-500/20 h-full">
        <div className="flex items-center gap-4 mb-4">
          <div className="p-3 bg-amber-900/50 rounded-full">
            <MapPin className="w-6 h-6 text-orange-300" />
          </div>
          <h3 className="text-xl font-semibold text-white">Event Location</h3>
        </div>

        <p className="text-gray-300 mb-4">3C Olaide Benson St, Ilupeju, Lagos</p>

        {/* Interactive Map */}
        <div
          onClick={openGoogleMaps}
          className="relative h-48 w-full rounded-lg overflow-hidden cursor-pointer group"
        >
          <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors z-10 flex items-center justify-center opacity-0 group-hover:opacity-100">
            <span className="px-4 py-2 bg-white/90 text-gray-900 rounded-lg font-medium">Get Directions</span>
          </div>
          <MapContainer
            center={[eventLatitude, eventLongitude]}
            zoom={15}
            className="h-full w-full rounded-lg shadow-lg"
            zoomControl={false}
          >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[eventLatitude, eventLongitude]}>
              <Popup>
                <button onClick={openGoogleMaps} className="text-blue-500 underline">
                  Get Directions
                </button>
              </Popup>
            </Marker>
          </MapContainer>
        </div>

        <div className="mt-4 flex justify-between items-center">
          <div className="text-sm text-gray-400">
            <span className="block">Sunday, February 28, 2025</span>
            <span className="block">6:00 PM WAT</span>
          </div>
          <button
            onClick={openGoogleMaps}
            className="px-4 py-2 bg-gradient-to-r from-orange-600 to-amber-600 text-white text-sm rounded-lg hover:from-orange-700 hover:to-amber-700 transition-all duration-300"
          >
            Directions
          </button>
        </div>
      </div>
    </div>
  );
}
// function SpeakersAndMinisters() {
//   const ministers = [
//     { id: 1, name: "Dr. Flourish Peters", role: "Speaker", image: ImagesDev.ministers.pflo },
//     { id: 3, name: "Pastor Lanre Olubaji", role: "Speaker", image: ImagesDev.ministers.pLanre },
//     { id: 4, name: "Pastor Noble G.", role: "Speaker", image: ImagesDev.ministers.png },
//     { id: 2, name: "Min. Mag Psalms", role: "Speaker", image: ImagesDev.ministers.magPsalm },
//   ];

//   const host = {
//     name: "Pst. TitOluwa Olumideko",
//     role: "Host & Lead Minister",
//     image: ImagesDev.ministers.minTSO,
//   };

//   return (
//     <section className="relative py-20 bg-gradient-to-b from-black to-gray-900 overflow-hidden">
//       <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1511367461989-f85a21fda167?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80')] opacity-10 bg-cover bg-center"></div>

//       <div className="container mx-auto px-4 relative z-10 max-w-6xl">
//         <div className="flex items-center justify-center gap-3 mb-12">
//           <User className="text-orange-400 w-8 h-8" />
//           <h2 className="text-4xl md:text-5xl font-bold text-white tracking-tight">
//             Speakers & Ministers
//           </h2>
//         </div>

//         <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-start">
//           {/* Host - Featured */}
//           <div className="lg:col-span-2 order-1 lg:order-1">
//             <div className="relative group">
//               <div className="absolute -inset-1 bg-gradient-to-r from-orange-600 to-pink-600 rounded-2xl blur opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
//               <div className="relative bg-gray-900 rounded-xl overflow-hidden">
//                 <img
//                   src={host.image}
//                   alt={host.name}
//                   className="w-full aspect-[3/4] object-cover object-center"
//                 />
//                 <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent pt-20 pb-6 px-6">
//                   <div className="flex items-center gap-2 mb-1">
//                     <Mic2 className="w-5 h-5 text-orange-400" />
//                     <p className="text-orange-300 font-medium">{host.role}</p>
//                   </div>
//                   <h3 className="text-2xl font-bold text-white">{host.name}</h3>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Ministers List */}
//           <div className="lg:col-span-3 order-2 lg:order-2 space-y-6 flex flex-col-reverse md:flex-col">
//             <div className="grid grid-cols-2 md:grid-cols-2 gap-6 mt-8 md:mt-0">
//               {ministers.map((minister) => (
//                 <div
//                   key={minister.id}
//                   className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl overflow-hidden hover:bg-gray-800/80 transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/20 group"
//                 >
//                   <div className="flex flex-col sm:flex-row items-center p-4">
//                     <div className="relative w-24 h-24 flex-shrink-0 mb-4 sm:mb-0">
//                       <div className="absolute inset-0 rounded-full bg-gradient-to-r from-orange-500 to-pink-500 animate-pulse opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
//                       <img
//                         src={minister.image}
//                         alt={minister.name}
//                         className="w-24 h-24 rounded-full object-cover border-2 border-orange-500/50 group-hover:border-orange-400 transition-all duration-300 relative z-10"
//                       />
//                     </div>
//                     <div className="sm:ml-5 text-center sm:text-left">
//                       <h3 className="text-xl font-bold text-white group-hover:text-orange-300 transition-colors duration-300">{minister.name}</h3>
//                       <p className="text-gray-400 text-sm mt-1 group-hover:text-gray-300 transition-colors duration-300">{minister.role}</p>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>

//             <div className="mt-8 bg-orange-900/20 backdrop-blur-sm border border-orange-800/30 rounded-lg p-6">
//               <h4 className="text-xl font-semibold text-white mb-3">Join Us For An Unforgettable Experience</h4>
//               <p className="text-gray-300">Experience powerful teachings and divine encounters with our distinguished speakers and ministers. Each brings unique insights and anointing to make this gathering truly transformative.</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }
//Don't Delete this function 👆








